// src/components/dashboard/DistributionPieChartCard.jsx
import React, { useEffect, useState } from 'react';
import { fetchStorageData } from '../../services/api.service';
import { DistributionChartLegend } from './ChartLegend';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const DistributionPieChartCard = () => {
  const [buckets, setBuckets] = useState({
    files: { size: 0 },
    passwords: { size: 0 },
    banking: { size: 0 },
    blockchain: { size: 0 }
  });
  const [loading, setLoading] = useState(true);

  const COLORS = ['#00CC5C', '#6f42c1', '#fd7e14', '#17a2b8'];

  useEffect(() => {
    const load = async () => {
      try {
        const token = sessionStorage.getItem('authToken');
        const data = await fetchStorageData(token);

        const mapping = {
          files: 'files',
          passwords: 'passwords',
          banking: 'bankcards',
          blockchain: 'blockchain'
        };

        const mappedBuckets = {};
        let total = 0;

        Object.entries(mapping).forEach(([key, realName]) => {
          const bucket = data.bucketSizes?.find(b => b.bucket === realName) || { size: 0 };
          mappedBuckets[key] = { size: bucket.size };
          total += bucket.size;
        });

        // Calculate percentages
        const percentages = {};
        Object.keys(mappedBuckets).forEach(key => {
          percentages[key] = total > 0 ? Math.round((mappedBuckets[key].size / total) * 100) : 0;
        });

        setBuckets({ ...mappedBuckets, _percentages: percentages });
      } catch (err) {
        console.error('Error loading distribution pie chart:', err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const pieData = [
    { name: 'Files', value: buckets.files.size },
    { name: 'Passwords', value: buckets.passwords.size },
    { name: 'Banking', value: buckets.banking.size },
    { name: 'Blockchain', value: buckets.blockchain.size }
  ];

  return (
    <div className="card h-100 shadow">
      <div className="card-body">
        <h6 className="font-weight-bold text-uppercase mb-3">Storage Distribution</h6>
        {loading ? (
          <div className="spinner-border text-success" role="status" />
        ) : (
          // Changed to always stack vertically - chart on top, legend at bottom
          <div className="d-flex flex-column align-items-center">
            {/* Chart container - centered at top */}
            <div className="chart-container mb-4" style={{ width: '100%', maxWidth: '300px' }}>
              <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                  <Pie
                    data={pieData}
                    dataKey="value"
                    outerRadius={80}
                    innerRadius={50}
                    paddingAngle={2}
                  >
                    {pieData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            
            {/* Legend container - full width at bottom */}
            <div className="w-100">
              <DistributionChartLegend
                buckets={buckets}
                percentages={buckets._percentages || {}}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DistributionPieChartCard;